/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import "./subscription-details.m.css";
import { CustomLink } from "../../custom-link";


import { getLocaleDate } from "../../../utils";

const TableHeader = ({ mySubscriptions }) => {
  const {
    planName: localizedPlanName = "",
    startDate: localizedStartDate = "",
    endDate: localizedEndDate = "",
  } = mySubscriptions;
  return (
    <div styleName="plan-details">
      <div styleName="content subs-detail-placeholder">{localizedPlanName || "Plan Name"}</div>
      <div styleName="content space subs-detail-placeholder">{localizedStartDate || "Start date"}</div>
      <div styleName="content subs-detail-placeholder">{localizedEndDate || "End date"}</div>
    </div>
  );
};

TableHeader.propTypes = {
  mySubscriptions: PropTypes.shape({
    planName: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

const NoSubscriptionMessage = ({ mySubscriptions }) => {
  const {
    noSubscription: localizedNoSubscriptionMsg = "",
    primeSubscription: localizedPrimeSubscription = "",
    buttonText: localizedButtonText = "",
  } = mySubscriptions;
  return (
    <div styleName="no-subs">
      <h3 styleName="no-subs-head">{localizedNoSubscriptionMsg || "No Subscriptions"}</h3>
      <p styleName="no-subs-content">
        {localizedPrimeSubscription ||
          "Subscribe to become prime member and get unlimited access to our exclusive stories."}
      </p>
      <div styleName="no-subs-btn">
        <CustomLink href={"/subscription"}>{localizedButtonText || "Subscribe now"}</CustomLink>
      </div>
    </div>
  );
};

NoSubscriptionMessage.propTypes = {
  localizedSubscribe: PropTypes.string,
  mySubscriptions: PropTypes.shape({
    noSubscription: PropTypes.string,
    primeSubscription: PropTypes.string,
    buttonText: PropTypes.string,
  }),
};

const SubscriptionList = ({ plans, localizedMonths = {} }) => {

  return plans.map((plan) => {
    const { id, plan_name: planName, start_timestamp: startDate, end_timestamp: endDate } = plan;
    return (
      <div key={id} styleName="plan-details">
        <div styleName="content">{planName}</div>
        {startDate && <div styleName="content space">{getLocaleDate(startDate, localizedMonths)}</div>}
        {endDate && <div styleName="content">{getLocaleDate(endDate, localizedMonths)}</div>}
      </div>
    );
  });
};

SubscriptionList.propTypes = {
  plans: PropTypes.array,
};

const SubscriptionsTable = ({ heading, plans, mySubscriptions, localizedMonths }) => {
  return (
    <div styleName="list">
      <h3 styleName="table-heading">{heading}</h3>
      <TableHeader mySubscriptions={mySubscriptions} />
      <SubscriptionList plans={plans} localizedMonths={localizedMonths} />
    </div>
  );
};

SubscriptionsTable.propTypes = {
  heading: PropTypes.string,
  plans: PropTypes.array,
  localizedMonths: PropTypes.object,
};

const SubscriptionsBlock = ({ subscriptions, mySubscriptions, localizedMonths }) => {
  const expiredPlans = subscriptions.filter(
    (plan) =>
      plan.status === "expired" &&
      (plan["subscription_type"] === "standard" || plan["subscription_type"] === "group_access")
  );
  const { activeSubscription = "", expiredSubscription = "" } = mySubscriptions;

  const activeplans = subscriptions
    .filter((plan) => plan["subscription_type"] === "standard" || plan["subscription_type"] === "group_access")
    .filter((plan) => plan.status === "active" || plan.status === "pending");

  if (!activeplans.length && !expiredPlans.length) return <NoSubscriptionMessage mySubscriptions={mySubscriptions} />;
  return (
    <>
      {!!activeplans.length && (
        <SubscriptionsTable
          heading={activeSubscription || "Active Subscriptions"}
          plans={activeplans}
          mySubscriptions={mySubscriptions}
          localizedMonths={localizedMonths}
        />
      )}
      {!!expiredPlans.length && (
        <SubscriptionsTable
          heading={expiredSubscription || "Expired Subscriptions"}
          plans={expiredPlans}
          mySubscriptions={mySubscriptions}
          localizedMonths={localizedMonths}
        />
      )}
    </>
  );
};

SubscriptionsBlock.propTypes = {
  subscriptions: PropTypes.array,
  localizedMonths: PropTypes.object,
  mySubscriptions: PropTypes.shape({
    activeSubscription: PropTypes.string,
    expiredSubscription: PropTypes.string,
  }),
};

export { SubscriptionsBlock };
